(function () {
  function initializeAccordian() {
    const accordian = document.querySelector('[data-product-accordian]');
    const DEFAULT_SCROLL_HEIGHT = 54;
    let selectedIndex = null;

    if (!accordian) return;

    const listItems = accordian.querySelectorAll('li');

    function getScrollHeight(el) {
      return el.querySelector('.product-accordian__content').scrollHeight + DEFAULT_SCROLL_HEIGHT + 'px'
    }

    function handleAccordianClick(e) {
      if (e.target.nodeName !== 'H3') return;
      
      const title = e.target
      const li = title.parentElement;
      const index = li.getAttribute('data-index');

      if (index === selectedIndex) {
        li.style.maxHeight = DEFAULT_SCROLL_HEIGHT + 'px';
        li.setAttribute('data-active', false);
        selectedIndex = null;
        return
      }

      listItems.forEach(function (el) {
        if (el.getAttribute('data-index') === index) {
          el.style.maxHeight = getScrollHeight(el);
          el.setAttribute('data-active', true);
        } else {
          el.style.maxHeight = DEFAULT_SCROLL_HEIGHT + 'px';
          el.setAttribute('data-active', false);
        }

        selectedIndex = index;
      })
    }

    accordian.addEventListener('click', handleAccordianClick);
  }

  initializeAccordian();
})();